var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{class:(_vm.path == 'academicArchives')&& _vm.$store.state.mini? 'academicArchives academicArchives-mini' : _vm.path,attrs:{"id":_vm.idNumber}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }